import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import SubscriptionPanel from './SubscriptionPanel';
import SubscriptionHistory from './SubscriptionHistory';

const tools = [
  {
    path: '/career-test',
    icon: 'ri-compass-3-line',
    title: '계열·진로·전공·직업 탐색',
    description: '흥미, 가치관, 적성 검사를 통해 나에게 맞는 계열과 진로 방향을 탐색합니다.',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    btnClass: 'bg-primary-500 hover:bg-primary-600 text-white',
  },
  {
    path: '/subject-guide',
    icon: 'ri-book-open-line',
    title: '고등학교 선택과목 추천',
    description: '나의 계열과 희망 전공에 맞는 핵심과목·권장과목을 안내합니다.',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    btnClass: 'bg-accent-500 hover:bg-accent-600 text-white',
  },
  {
    path: '/study-style',
    icon: 'ri-brain-line',
    title: '성격·성향 기반 공부법 검사',
    description: 'VARK 학습 유형과 MBTI를 분석하여 과목별 최적 공부 전략을 제안합니다.',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-700',
    btnClass: 'bg-primary-700 hover:bg-primary-800 text-white',
  },
  {
    path: '/iq-test',
    icon: 'ri-psychotherapy-line',
    title: '종합 인지능력(IQ) 검사',
    description: '4개 영역 100문항으로 종합적인 인지능력을 추정합니다.',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    btnClass: 'bg-accent-500 hover:bg-accent-600 text-white',
  },
  {
    path: '/literacy-test',
    icon: 'ri-book-read-line',
    title: '어휘력·문해력 검사',
    description: '어휘력과 문해력을 정밀 진단해 국어 기초 학력을 점검합니다.',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    btnClass: 'bg-secondary-500 hover:bg-secondary-600 text-white',
  },
  {
    path: '/english-test',
    icon: 'ri-book-open-line',
    title: '영어 단어 검사',
    description: '초·중·고 단계별 5가지 유형으로 영어 어휘력을 진단합니다.',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    btnClass: 'bg-accent-500 hover:bg-accent-600 text-white',
  },
];

export default function MemberDashboard() {
  const { profile, refreshProfile } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="space-y-8">
      {/* 환영 카드 */}
      <div className="bg-white rounded-xl border border-background-200 p-6" data-print="hide">
        <div className="flex items-center gap-4 flex-wrap">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
            <i className="ri-user-star-line text-2xl"></i>
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="font-heading text-xl font-bold text-foreground-950">
              {profile?.full_name}님, 환영합니다!
            </h1>
            <p className="text-sm text-foreground-500 mt-1">
              개인 이용권으로 모든 진로탐구 도구를 이용하실 수 있습니다.
            </p>
          </div>
        </div>
      </div>

      {/* 구독 상태 */}
      <div data-print="hide">
        {profile && <SubscriptionPanel profile={profile} onChanged={refreshProfile} />}
      </div>

      {/* 구매내역 */}
      <div data-print="hide">
        {profile && <SubscriptionHistory userId={profile.id} />}
      </div>

      {/* 도구 안내 */}
      <div data-print="hide">
        <h2 className="font-heading text-lg font-bold text-foreground-950 mb-1">
          진로탐구 도구
        </h2>
        <p className="text-foreground-500 text-sm mb-4">
          아래 도구들을 활용해 나에게 맞는 진로와 공부법을 찾아보세요.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {tools.map((tool) => (
            <div
              key={tool.path}
              className="bg-white rounded-xl border border-background-200 overflow-hidden group cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => navigate(tool.path)}
            >
              <div className="p-5">
                <div className="flex items-start gap-3 mb-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${tool.iconBg}`}>
                    <i className={`${tool.icon} text-lg ${tool.iconColor}`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 text-base leading-tight pt-1.5">
                    {tool.title}
                  </h3>
                </div>
                <p className="text-foreground-600 text-sm mb-4 leading-relaxed">{tool.description}</p>
                <button
                  className={`whitespace-nowrap w-full py-2.5 rounded-lg text-sm font-semibold ${tool.btnClass} transition-colors cursor-pointer`}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(tool.path);
                  }}
                >
                  시작하기 <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}